const clientType = process.env.REACT_APP_CLIENT;

let x_key: string;
let session_tenantId: string;
let apiKey: string;
let tenantId: string;

switch (clientType) {
  case "salesbot2290ai":
    x_key = "salesBot-2290AI";
    session_tenantId = "salesBot2290AI";
    apiKey = "salesBot-2290AI";
    tenantId = "salesBot2290AI";
    break;
  case "salesbottax1099":
    x_key = "salesBot-Tax1099";
    session_tenantId = "salesBotTax1099";
    apiKey = "salesBot-Tax1099";
    tenantId = "salesBotTax1099";
    break;
  default:
    x_key = "salesBot-Tax1099";
    session_tenantId = "salesBotTax1099";
    apiKey = "salesBot-Tax1099";
    tenantId = "salesBotTax1099";
    break;
}
export { x_key, session_tenantId }

export const socketConfig = {
  autoConnect: false,
  // reconnection: true, // Enable automatic reconnection
  // reconnectionAttempts: 5, // Number of attempts before giving up
  // reconnectionDelay: 1000,
  auth: {
    apiKey,
    tenantId,
    channel: 'web',
    authToken: '{}',
  },
  withCredentials: true,
};
